import { reactive } from "vue";

export const toolbarStore = reactive({
    prevPoint: {x: 0, y: 0}
});

